import { render, staticRenderFns } from "./DocumentMiscOptions.vue?vue&type=template&id=0daa3cae&scoped=true&"
import script from "./DocumentMiscOptions.vue?vue&type=script&lang=js&"
export * from "./DocumentMiscOptions.vue?vue&type=script&lang=js&"
import style0 from "./DocumentMiscOptions.vue?vue&type=style&index=0&id=0daa3cae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0daa3cae",
  null
  
)

export default component.exports